/* eslint-disable max-len */
/* eslint-disable object-property-newline */
import router from './router';
import NProgress from 'nprogress';
import 'nprogress/nprogress.css';
import { Message } from 'element-ui';
import { Route } from 'vue-router';
import { userModule } from '@/store/modules/ModuleUser';
import { permissionModule } from '@/store/modules/ModulePermission';
import i18n from '@/lang';
import { AppDecorater } from './AppDecorater';
import settings from './AppSettings';
import { appModule, ISceneMode, SceneConstType } from '@/store/modules/ModuleApp';
import serviceCommon from '@/service/ServiceCommon';
import {
	busEvent,
	EventBusEnum,
	getLocalStorage,
	InterceptorLocalAuth,
	getQueryVariable,
	isDevAndTestEnvirement,
	removeLocalStorage,
	setLocalStorage,
	CrossDomainSync,
	configService
} from '@tencent/s2-client-vue-lib';
import axios from 'axios';
import { IRequireLevel, INation, systemModule, ITaxtCode, ICurrency } from './store/modules/ModuleSystem';
import {
	LOCAL_STORE_USER_INFO,
	getRequireLevelListData,
	getNationListData,
	LAST_INVOKE_PERMISSION_URL,
	getLastInvokeUserKey,
	TEMP_PERMISSION_URL,
	FORBIDDEN_PAGE,
	SECOND_HOME_PAGE,
	CROSS_DOMAIN_SYNC_OPTIONS, CROSS_DOMAIN_KEY_VENDOR_FULL_VALUE
} from './libs/LibsStatus';
import { reportCrossDomainSyncOperation } from '@/libs/LibsCrossDomainReport';
import { IndexController } from './views/index';
import { getReportIdByKey, transferReportData } from './libs/LibsReporHelper';
import { getHashParams } from './libs/LibsThrottler';
import LibsModelSceneMixins from './libs/LibsModelSceneMixins';
import ServiceCas from './service/ServiceCas';
import Vue, { DirectiveOptions } from 'vue';
import configDefault from './config/ConfigDefault';
import { qualificationModule } from './store/modules/ModuleQualification';
import serviceBaseData from '@/service/ServiceBaseData';
import ServiceSystem from './service/ServiceSystem';

/**
 * App permission manager
 * @class AppPermission
 */
class AppPermission {
	/** white list */
	public whiteList: Array<string> = ['/login', '/logout', '/auth-redirect'];

	/** 菜单数据 */
	public menuData: any;

	/**
	 * CrossDomainSync 实例，用于跨域/跨 Tab 数据共享
	 */
	public sync: any = new CrossDomainSync(CROSS_DOMAIN_SYNC_OPTIONS);

	/** constructor */
	constructor() {
		const decorater: AppDecorater = new AppDecorater();

		decorater.init();
	}

	/** get title */
	public getPageTitle(key: string): any {
		const hasKey: any = i18n.te(`route.${key}`);

		if (hasKey) {
			const pageName: any = i18n.t(`route.${key}`);

			return `${pageName} - ${settings.title}`;
		}

		return `${settings.title}`;
	}

	/** 路由监听跳转 */
	private async monitorRouteStatus(): Promise<any> {
		// console.log('Start progress bar..');

		router.beforeEach(async (to: Route, _: Route, next: any) => {
			// Start progress bar
			NProgress.start();

			// Determine whether the user has logged in
			if (userModule.token) {
				if (to.path === '/login') {
					// If is logged in, redirect to the home page
					next({ path: '/' });
					NProgress.done();
				} else {
					// Check whether the user has obtained his permission roles
					// eslint-disable-next-line no-lonely-if
					if (userModule.roles.length === 0) {
						try {
							await this.generateDynamicRoutes();

							next({ ...to, replace: true });
						} catch (err) {
							// Remove token and redirect to login page
							userModule.resetToken();
							// Message.error(err || 'Has Error');
							next(`/login?redirect=${to.path}`);
							// next();
							NProgress.done();
						}
					} else {
						next();
					}
				}
			} else {
				// Has no token
				// eslint-disable-next-line no-lonely-if
				if (this.whiteList.indexOf(to.path) !== -1) {
					// In the free login whitelist, go directly
					next();
				} else {
					// Other pages that do not have permission to access are redirected to the login page.
					// next(`/login?redirect=${to.path}`);

					// 如果没有匹配的项跳转到403
					if (to.matched.length === 0) {
						next({ path: '/403' });
					} else {
						next();
					}

					NProgress.done();
				}
			}
		});

		router.afterEach((to: Route) => {
			// console.log('router.after each');

			// Finish progress bar
			NProgress.done();

			// set page title
			document.title = this.getPageTitle(to.meta.title);

			// change breads status sub page
			if (to.path.indexOf(appModule.INDEX_PAGE_PATH) > -1) {
				appModule.setShowBreads(false);
			} else {
				appModule.setShowBreads(true);
			}

			// entrance page
			if (to.path.indexOf(appModule.ENTRANCE_PAGE_PATH) > -1) {
				appModule.setEntranceFlag(false);
			} else {
				appModule.setEntranceFlag(true);
			}
		});
	}

	/**
	 * 生成动态路由
	 * @private
	 * @returns {Promise<any>}
	 * @memberOf AppPermission
	 */
	private async generateDynamicRoutes(navMenus: Array<any> = []): Promise<any> {
		permissionModule.filterRoutes(navMenus);
		console.log('navMenus: ', navMenus);

		// 匹配不到内容重定向到403，同时保留路由结构
		console.log('permissionModule.dynamicRoutes: ', permissionModule.dynamicRoutes);
		if (permissionModule.dynamicRoutes.length) {
			// router.addRoutes(
			// 	permissionModule.dynamicRoutes.concat([
			// 		{
			// 			path: '/:pathMatch(.*)*',
			// 			name: 'NotFound',
			// 			component: (): any => import(/*  webpackChunkName: "secondHomePage" */ '@/views/index/error-home-page/index.vue')
			// 		}
			// 	])
			// );

			// TIPS:传统模式
			// router.addRoutes(permissionModule.dynamicRoutes);
			console.log('permissionModule.dynamicRoutes==>', permissionModule.dynamicRoutes);
		}
		// Hack: ensure addRoutes is complete
		// Set the replace: true, so the navigation will not leave a history record

		return permissionModule.dynamicRoutes;
	}

	/** 还原用户常用历史列表 */
	protected async restoreUserSelectedHistory(): Promise<any> {
		// console.log('restoreUserSelectedHistory..');
		const indexController = new IndexController();
		const storageKey: string = indexController.getUserHistoryKey();
		const userHistoryList = getLocalStorage(storageKey) || [];

		// 判断当前参数是否存在CODE，如果存在，取后端数据存入
		const queryData: any = getHashParams();
		if (queryData && queryData.code) {
			const modelData: any = await serviceCommon.fetchModelSceneDataByCode(queryData.code);
			console.log('fetch data', modelData);

			// 如果存在，取后端数据存入
			if (modelData && modelData.data) {
				indexController.saveUserSelect(modelData.data.scene, modelData.data.model, modelData.data.businessLine);
			}
		} else {
			// 当前是从首页进去的取第一条记录，取本地存入
			if (userHistoryList && userHistoryList.length) {
				const item: any = userHistoryList[0];
				console.log('还原时获取用户第一个值', item.scene, item.model.modelCode, item.businessLine);
				indexController.saveUserSelect(item.scene, item.model.modelCode, item.businessLine);

				if (window.location.href.indexOf(appModule.SECOND_PAGE_PATH) !== -1) {
					appModule.setEntranceFlag(true);
				}
			} else {
				// 取默认值
				indexController.saveUserSelect(SceneConstType.SCENE_QCP, SceneConstType.MODEL_CDP, SceneConstType.PCG);
			}
		}
	}

	/**
	 * 模拟登录
	 * @private
	 * @returns {Promise<any>}
	 * @memberOf AppPermission
	 */
	public async sumilateLogin(): Promise<any> {
		// 检测是否从登录回来的情况,如果是，去除登录信息
		if (window.location.href.indexOf('sessionKey=') !== -1) {
			const realUrl: string = `${window.location.protocol}//${window.location.host}`;
			window.location.href = realUrl;

			return;
		}

		// 监听场景模式数据更新
		// 分2种情况
		// 1.从缓存中还原时
		// 2.用户主动选择存入时
		await busEvent.$on(EventBusEnum.APPS_SCENE_FEED_BACK, this.onSceneFeedBack.bind(this));
		// axios.get('http://test-na-sms-bidding.tencent.com/login/callback');
		// await ServiceSystem.callbackLogin();
		// window.location.href = 'http://test-na-sms-bidding.tencent.com/login/callback';

		// TIPS: delete sumilate login
		const sumilateLoginResult: any = await userModule.login({
			username: 'admin',
			password: '111111'
		});

		// 获取菜单数据
		// this.menuData = this.formatProfile(await ServiceCas.getProfile());
		// console.log(JSON.stringify(this.menuData));

		// this.menuData = {
		// 	status: 0,
		// 	data: {
		// 		user: {
		// 			id: 10728,
		// 			nickName: null,
		// 			fullName: 'na-supplier-230130',
		// 			roles: null,
		// 			avatar: null,
		// 			loginTime: null,
		// 			loginAddress: null,
		// 			permissions: null,
		// 			ouId: null,
		// 			ouName: null,
		// 			bgId: null,
		// 			bgName: null,
		// 			deptId: null,
		// 			deptName: null,
		// 			staffTypeId: null,
		// 			staffTypeName: null,
		// 			vendorId: 700001205,
		// 			userId: 700001205,
		// 			supplierSubUserId: 10003405
		// 		},
		// 		navMenus: [],
		// 		currentTime: 1688615515592
		// 	},
		// 	message: null,
		// 	success: true
		// };
		// 禁用演示模式
		localStorage.setItem('currentStatus', 'dynamic');
		console.log('get profile..', this.menuData);

		if (localStorage.getItem('currentStatus') === 'dynamic') {
			this.menuData = await serviceCommon.getPageHeader();
		} else {
			this.menuData = {
				successful: 1,
				errorCode: null,
				errorMsg: null,
				data: {
					user: {
						id: 0,
						nickName: '',
						fullName: 'Qichacha (Beijing) Technology',
						roles: null,
						avatar: null,
						loginTime: null,
						loginAddress: null,
						permissions: null,
						ouId: null,
						ouName: null,
						bgId: null,
						bgName: null,
						deptId: null,
						deptName: null,
						staffTypeId: null,
						staffTypeName: null,
						vendorId: 700003801,
						userId: 10006001,
						supplierSubUserId: null
					},
					navMenus: null,
					currentTime: 1690526198517,
					urlConfig: {}
				}
			};
		}
		// 根据地址栏参数useLogin=true调用登录接口
		// const urlQuary = window.location.href;
		// if (urlQuary.indexOf('useLogin=true') !== -1) {

		// 增加测试菜单
		console.log('this.menuData.data==', this.menuData.data);

		if (this.menuData.data.user.id === 0) {
			this.menuData.data.user.id = this.menuData.data.user.vendorId || this.menuData.data.user.userId;
		}

		this.menuData.data.navMenus = [];
		// }

		// 存取用户信息
		if (this.menuData && this.menuData.data && this.menuData.data.user) {
			console.log('sumilate login');
			// 回来时-拦截本地内登录参数-只有开发服和测试服才执行
			if (isDevAndTestEnvirement()) {
				console.log('sumilate login isDevAndTestEnvirement');
				await new InterceptorLocalAuth().interceptorDevelopement();
			}

			const { user, navMenus, dsSwitchInfo, multiVendorListResultBean }: any = this.menuData.data;
			let userData = user

			// let userInfo = (await serviceBaseData.getUserInfo([userData.id]))?.data?.[0];
			// console.log('userInfo==>', JSON.stringify(userInfo));

			const pvendorPartyId = this.sync.get(CROSS_DOMAIN_KEY_VENDOR_FULL_VALUE);
			// 查找cookie里面的pvendor-id是否在当前用户列表中有，有的话就更新当前用户信息，没有的话说明是第一次登录或者之前的值被清除了，重新设置值
			const pvendorItem = multiVendorListResultBean?.list?.find((item: any) => String(item.pvendorPartyId) === String(pvendorPartyId));
			// 处理用户列表数据
			if (pvendorPartyId && pvendorItem) {
				userData = {
					...userData,
					userId: pvendorItem.userId,
					vendorId: pvendorItem.pvendorPartyId,
					fullName: pvendorItem.vendorFullName
				};
				// 处理逻辑
			} else {
				// cookie里面没有值或者是vendorList里面没有符合的供应商账号，说明是第一次登录或者之前的值被清除了或者是别的账号的，所以要重新设置值
				this.sync.set(CROSS_DOMAIN_KEY_VENDOR_FULL_VALUE, userData.userId || '');
				reportCrossDomainSyncOperation('set', CROSS_DOMAIN_KEY_VENDOR_FULL_VALUE, userData.userId || '');
			};


			console.log('this.sync.get(CROSS_DOMAIN_KEY_VENDOR_FULL_VALUE)====', this.sync.get(CROSS_DOMAIN_KEY_VENDOR_FULL_VALUE));
			// 更新请求头，携带供应商ID
			configService.setCustomHeadersGetter(() => ({
				'pvendor-id': this.sync.get(CROSS_DOMAIN_KEY_VENDOR_FULL_VALUE) || ''
			}));

			// 保存DS开关
			systemModule.saveDsSwitchInfo(dsSwitchInfo);

			setLocalStorage(LOCAL_STORE_USER_INFO, userData);
			setLocalStorage('navMenus', navMenus);
			setLocalStorage('authorityData', this.menuData.data);

			userModule.setUserData(userData);
			userModule.setUserDataList(multiVendorListResultBean?.list || []);
			userModule.setCanSwitch(multiVendorListResultBean?.canSwitch || false);

			/** 添加小助手 */
			// this.appendScript();

			// 首次设置，存入用户信息入全局对象
			await this.restoreUserSelectedHistory();

			this.monitorRouteStatus();

			// 生成最终过滤后路由
			const dynamicRoutes: any = await this.generateDynamicRoutes(navMenus);

			NProgress.configure({
				showSpinner: false
			});
		}

		return sumilateLoginResult;
	}

	/** 格式化用户数据 */
	private formatProfile(data: any): any {
		const result: any = { code: 200, data: {} };
		result.code = data.code;
		result.data.menus = this.formatMenus(data.data.menus);
		result.data.userData = data.data.user;

		return result;
	}

	/** 格式化菜单 */
	private formatMenus(menus: any[]): any[] {
		if (!menus || menus.length <= 0) {
			return [];
		}

		return menus.map((m) => {
			m.code = m.codeName.code;
			m.name = m.codeName.name;
			m.value = m.code;
			m.childMenu = this.formatMenus(m.subMenus);

			return m;
		});
	}

	/** 遍历菜单是否包含权限 */
	private findByRestoreUrl(dynamicRoutes: Array<any>, lastUrl: string, findedObj: any): void {
		for (let index = 0; index < dynamicRoutes.length; index++) {
			const elementParent = dynamicRoutes[index];
			const elementBase = elementParent.name;

			for (let indexSub = 0; indexSub < elementParent.children.length; indexSub++) {
				const elementSub = elementParent.children[indexSub];
				const matchUrl: string = `/${elementBase}/${elementSub.name}`;
				if (lastUrl === matchUrl) {
					findedObj.finded = true;
					break;
				}
			}
		}
	}

	/**
	 * 场景模式回填入STORE
	 *
	 * @private
	 * @param {*} sceneData
	 *
	 * @memberOf AppPermission
	 */
	private async onSceneFeedBack(sceneData: ISceneMode): Promise<any> {
		appModule.setSceneMode(sceneData);

		// 将模式场景存入后端: TODO: 后续由首页调用
		console.log(
			'将模式场景存入后端,在设置场景后调用: ',
			'model=',
			sceneData.model,
			'scene=',
			sceneData.scene,
			'businessLine=',
			sceneData.businessLine
		);
		const setData: any = await serviceCommon.setModeAndScene(sceneData);
		console.log('延迟调用-将模式场景存入后端,在设置场景后调用@# end');

		// 菜单在设置模式场景后返回
		if (setData && setData.data && setData.data.navMenus) {
			this.generateDynamicRoutes(setData.data.navMenus);
		}

		if (setData && setData.status === 0) {
			// 存入是否已向后端存入模式场景标记
			appModule.setIsSceneModeSetted(true);
		}
	}

	/**
	 * 添加小助手
	 *
	 * @private
	 *
	 * @memberOf AppDecorater
	 */
	private appendScript(): void {
		const appendScript = document.createElement('script');
		appendScript.type = 'text/javascript';
		appendScript.async = true;
		appendScript.defer = true;
		appendScript.src = 'https://oa-jarvis-i18n.tencent.com/current/ui/js/helper-en.js';
		(document.getElementsByTagName('head')[0] || document.getElementsByTagName('body')[0]).appendChild(appendScript);
	}
}

export default new AppPermission();
